import { useCallback } from 'react';

import { useTrackCanvasDraftAbandoned } from '@air/analytics';
import { useEditCanvasStore } from '@air/feature-edit-canvas';

import { useWorkspaceRightPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceRightPanelStore';

/**
 * Shared hook that fires canvas_draft_abandoned analytics and clears draft state.
 * Used by useDraftCanvas and useSelectedCanvasId to
 * avoid duplicating the abandonment pattern.
 */
export const useDiscardDraftCanvas = () => {
  const { trackCanvasDraftAbandoned } = useTrackCanvasDraftAbandoned();

  return useCallback(() => {
    const draft = useWorkspaceRightPanelStore.getState().draftCanvas;

    if (draft) {
      trackCanvasDraftAbandoned(draft.analyticsContext);
      useWorkspaceRightPanelStore.getState().setDraftCanvas(null);
      // Drafts share the '' id — clear greeting and the had-content latch so the next draft
      // is a new visit. The latch is store-backed (survives overlay remount), so discard
      // has to reset it; a remount will not.
      useEditCanvasStore.getState().setNullStateGreetedCanvasId(null);
      useEditCanvasStore.getState().resetHasEverHadNodesVisit();
    }
  }, [trackCanvasDraftAbandoned]);
};
